import { combineReducers } from 'redux';
import { reducer as base } from './base';
import { reducer as sharing } from './sharing';
import { reducer as dashboard } from './dashboard';
import { reducer as tempDashboard } from './tempDashboard';

export default combineReducers({
  base,
  sharing,
  dashboard,
  tempDashboard,
});
